/**
 * Created by litao on 2018/10/8.
 */
import de from "element-ui/src/locale/lang/de";

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage (data){
            return http.json({
                url: `/sys/account/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        querySkuAdmin (data){
            return http.json({
                url: `/sys/account/querySkuAdmin?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        queryByReceive(data) {
            return http.json({
                url: `/sys/account/queryByReceive?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        getInfo (data){
            return http.json({
                url: `/sys/account/get?id=${data.id}`,
                data
            })
        },
        getInfoAndShAddress (data){
            return http.json({
                url: `/sys/account/getInfoAndShAddress?id=${data.id}`,
                data
            })
        },
        queryUserList(data){
            return http.json({
                url: `/sys/account/queryAll`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/sys/account/saveAndAccredit`,
                data
            })
        },
        saveCourseAccount(data){
            return http.json({
                url: `/sys/account/saveCourseAccount`,
                data
            })
        },

        saveUser (data){
            return http.json({
                url: `/sys/account/saveUser`,
                data
            })
        },
        toggleState(data){
            return http.json({
                url: `/sys/account/toggleState`,
                data
            })
        },
        disable(data){
            return http.json({
                url: `/sys/account/disable`,
                data
            })
        },
        recover(data){
            return http.json({
                url: `/sys/account/recover`,
                data
            })
        },
        saveJxs (data){
            return http.json({
                url: `/sys/account/saveAndAccreditAdmin`,
                data
            })
        },


        saveOther (data){
            return http.json({
                url: `/sys/account/saveOther`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/sys/account/delete`,
                data
            })
        },
        /**
         * 修改用户密码
         * @param data
         */
        modifyPassword (data){
            return http.json({
                url: '/sys/account/modifyPassword',
                data
            });
        },


        saveAccountAndWarrantyCard(data) {
            return http.json({
                url: `/erp/warranty/card/saveAccountAndWarrantyCard`,
                data
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/personal.js